import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-date-picker";

export const siteId70903: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2135/EMEA_Autumn_Switzerland_1400x600.jpg",
  },
  car: {
    driveAgeCheckbox: true,
    date: {
      firstDayOfWeek: DayName.MON,
    },
    includeGT: false,
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    enablePackageRates: true,
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/UK.HPR.012021.pdf",
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
};
